import { nanoid } from 'nanoid';

import { logger } from '@ui-furniture/common/services/logger';

import { CreateMemento } from './types/create-memento';
import { Memento } from './types/memento';

export class MementoService {
  private _mementoCreators: CreateMemento[] = [];
  private _snapshotMementos = new Map<string, Memento>();

  private _deleteSnapshotsAfterId = (idToMatch: string) => {
    let shouldDelete = false;
    this._snapshotMementos.forEach((_memento, snapshotId) => {
      if (snapshotId === idToMatch) shouldDelete = true;
      if (shouldDelete) this._snapshotMementos.delete(snapshotId);
    });
  };

  registerMementoCreator = (createMemento: CreateMemento) => {
    this._mementoCreators.push(createMemento);
  };
  registerMementoCreators = (mementoCreators: Array<CreateMemento>) => {
    this._mementoCreators = [...this._mementoCreators, ...mementoCreators];
  };

  saveSnapshot = () => {
    const snapshotId = nanoid();
    const individualMementos = this._mementoCreators.map((createMemento) =>
      createMemento()
    );
    const snapshotMemento: Memento = {
      restore: () => {
        individualMementos.forEach((memento) => memento.restore());
        this._deleteSnapshotsAfterId(snapshotId);
      },
    };

    this._snapshotMementos.set(snapshotId, snapshotMemento);

    return snapshotMemento;
  };

  restorePrevious = () => {
    const previousSnapshot = this.getLatestSnapshot();

    if (previousSnapshot) {
      previousSnapshot.restore();

      return true;
    }
    return false;
  };

  getLatestSnapshot = () => {
    const latestSnapshot = Array.from(this._snapshotMementos.values()).pop();
    if (!latestSnapshot) {
      logger.error('Latest snapshot requested but none found');
      return {
        restore: () => {
          logger.error(`Tried to restore to a memento that doesn't exist`);
        },
      };
    }
    return latestSnapshot;
  };
}
